import { Sparkles } from "lucide-react";

const items = [
  "SANS FRAIS CACHÉS",
  "CONVERSION OPTIMISÉE",
  "CHARGEMENT < 1.5S",
  "DESIGN SUR-MESURE",
  "HÉBERGEMENT CLOUD INCLUS",
  "SUPPORT RÉACTIF < 24H",
  "SANS RISQUE DE TRÉSORERIE",
];

export default function Marquee() {
  const row = [...items, ...items];
  return (
    <div
      className="relative overflow-hidden border-y border-white/5 bg-[#0A0F16] py-5"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((text, i) => (
          <span
            key={i}
            className="flex items-center gap-10 text-xs uppercase tracking-[0.3em] text-gray-500"
            style={{ fontFamily: "'JetBrains Mono', monospace" }}
          >
            {text}
            <Sparkles className="h-3.5 w-3.5 text-emerald-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
